import { IconComponent } from 'models/icons';

/**
 * This file was auto-generated using svgr
 *
 * Source file: assets/icons/cylinder.svg
 */
const IconCylinder: IconComponent = ({
  size = 24,
  color = 'white',
  className,
  svgElementProps: props = {},
}) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    color={color}
    className={className}
    {...props}
  >
    <path
      d="M20.5 3.93c0-.702-.468-1.7-2.696-2.477a20.448 20.448 0 00-11.608 0C3.968 2.23 3.5 3.228 3.5 3.929c0 .154.022.306.066.453v15.233a1.587 1.587 0 00-.066.451c0 .702.468 1.7 2.696 2.478a20.378 20.378 0 0011.608 0c2.212-.777 2.696-1.776 2.696-2.478 0-.113-.012-.225-.035-.335V4.267a1.58 1.58 0 00.035-.338zM6.556 2.487a19.333 19.333 0 0110.888 0c1.447.503 1.962 1.09 1.962 1.441v.045a.815.815 0 00-.029.117c-.13.351-.685.847-1.93 1.283a19.367 19.367 0 01-10.888 0A3.375 3.375 0 014.663 4.17c0-.09-.023-.18-.067-.26.026-.344.55-.932 1.954-1.422h.006zM4.66 18.316V5.675c.479.304.994.548 1.533.727a20.448 20.448 0 0011.608 0 6.87 6.87 0 001.564-.746v14.43a.448.448 0 000 .116c-.117.354-.67.86-1.937 1.302a19.364 19.364 0 01-10.887 0c-1.214-.423-1.77-.903-1.92-1.264a.58.58 0 00.026-.163v-.263"
      fill="currentColor"
    />
  </svg>
);

export default IconCylinder;
